import React, { useContext, useEffect, useState } from 'react';
import { __RouterContext } from 'react-router';
import { useLocation } from 'react-router-dom';

const usePathname = () => {
  const [pathname, setPathname] = useState(null);

  useEffect(() => {
    const updatePathname = (e) => {
      setPathname(e.detail.pathname);
    };

    document.addEventListener('appPageView', updatePathname);

    return () => {
      document.removeEventListener('appPageView', updatePathname);
    }
  }, []);

  // Checking if the router context exists is a method of seeing if we are inside of the SPA.
  // https://stackoverflow.com/questions/59992359/how-can-i-check-if-react-router-is-in-context
  const router = useContext(__RouterContext);

  if (pathname) {
    return pathname;
  } else if (router) {
    return useLocation().pathname;
  } else if (typeof window !== 'undefined') {
    return window.location.pathname;
  } else {
    return null;
  }
}

export default usePathname;
